import { today, todayAdd } from '@/features/dates/date-helpers';
import type { GetSavedGroupsQuery } from '@/features/group-pricing/gql/_gen_/group-pricing.gql';
import { useGroupPricing } from '@/features/group-pricing/hooks/use-group-pricing';
import type { GroupPricing } from '@/graphql/gql-types';
import type { ApolloError } from '@apollo/client';
import { createContext, useState } from 'react';

type GroupPricingFormValues = GroupPricing & {
	check_in: string;
	check_out: string;
};

const defaultFormValues: GroupPricingFormValues = {
	adr_fcst_override: 0,
	avg_stay_length: 1.25,
	check_in: today(),
	check_out: todayAdd(1, 'day'),
	commission: 5,
	comp_rooms: 0,
	direct_var_opex: 35,
	f_and_b_profit: 0,
	group_name: '',
	meeting_space_benefit: 0,
	occ_fcst_override: 0,
	planners_adv_points: 0,
	profit_margin: 10,
	rate_requested: 100,
	rebate: 0,
	rooms_requested: 5,
	wash_factor: 10,
};

interface GroupPricingContextType {
	activeGroup?: GroupPricing;
	data?: GetSavedGroupsQuery['getSavedGroups'];
	defaultFormValues: GroupPricingFormValues;
	error?: ApolloError;
	loading: boolean;
	setActiveGroup: (group?: GroupPricing) => void;
}

export const GroupPricingContext =
	createContext<GroupPricingContextType | null>(null);

interface GroupPricingProviderProps {
	children: React.ReactNode;
}

export const GroupPricingProvider = ({
	children,
}: GroupPricingProviderProps) => {
	const { savedGroups, error, loading } = useGroupPricing();
	const [activeGroup, setActiveGroup] = useState<GroupPricing>();

	return (
		<GroupPricingContext.Provider
			value={{
				activeGroup,
				data: savedGroups,
				defaultFormValues,
				error,
				loading,
				setActiveGroup,
			}}
		>
			{children}
		</GroupPricingContext.Provider>
	);
};
